import { getAppConfigValue } from "@elliemae/pui-app-sdk";
import { LogRocket, initLogRocket } from "@elliemae/pui-logrocket";
import { randomUUID } from "@frontend/utils";
function initializeLogRocket(config) {
  const appId = config?.appId ?? getAppConfigValue("logRocketConfig.appId");
  const parentDomain = config?.parentDomain ?? getAppConfigValue("logRocketConfig.parentDomain");
  const rootHostname = config?.rootHostname ?? getAppConfigValue("logRocketConfig.rootHostname");
  const childDomains = config?.childDomains ?? getAppConfigValue("logRocketConfig.childDomains");
  window.process = window.process || { env: {} };
  initLogRocket({
    appId,
    parentDomain,
    rootHostname,
    childDomains
  });
  LogRocket.startNewSession();
}
function identifyLogRocketUser(traits, userId) {
  const id = userId ?? randomUUID();
  LogRocket.identify(id, traits);
}
export {
  identifyLogRocketUser,
  initializeLogRocket
};
